<div *ngIf="results && results.results" class="results" [ngClass]="{
    'results--empty': !results.results.length
}">
    <div *ngIf="results.results.length" class="apps">
        <div *ngFor="let appResult of results.results; let appIndex = index; trackBy: trackByIndex" class="app">
            <div class="app-header">
                <div class="app-name">
                    {{appResult.application}}
                </div>
            </div>

            <div *ngFor="let categoryResult of appResult.categories; let categoryIndex = index; trackBy: trackByIndex" class="category">
                <div *ngIf="displayCategory" class="category-name">
                    {{categoryResult.category}}
                </div>

                <div class="pages">
                    <a
                        *ngFor="let pageResult of categoryResult.pages; let pageIndex = index; trackBy: trackByIndex"
                        class="page"
                        routerLink="/{{pageResult.application_slug}}/{{pageResult.category_slug}}/{{pageResult.slug}}"
                    >
                        <div class="page-name">{{pageResult.name}}</div>
                        <div class="snippet">
                            <span
                                *ngFor="let snippetPart of getSnippet(appIndex, categoryIndex, pageIndex); trackBy: trackByIndex"
                                class="snippet-part"
                                [ngClass]="{
                                    'snippet-part--highlight': snippetPart.match
                                }"
                            >{{snippetPart.text}}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="!results.results.length" class="no-results">
        No results found.
    </div>
</div>
